  <span class="input-error" *ngFor="let error of errorStrs">{{error}}</span>
